// extracted by mini-css-extract-plugin
module.exports = {"container":"Toast_container__2VNlV","generic":"Toast_generic__3jIPx","success":"Toast_success__2MU6A","failure":"Toast_failure__18fm7","iconWrapper":"Toast_iconWrapper__3zF33"};